import React, { FC, useMemo } from 'react';
import { ILocalAudioTrack } from 'agora-rtc-sdk-ng';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { useObservable } from 'react-use';
import { IconButton, Tooltip } from '@material-ui/core';
import { Mic, MicOff } from '@material-ui/icons';
import styled from 'styled-components';

const StyledMicColorOverlayContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 1em;
  width: 1em;
  display: flex;
  align-items: flex-end;
`;

const StyledMicColorOverlay = styled.div`
  color: lawngreen;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const StyledMic = styled(Mic)`
  position: absolute;
  bottom: 0;
  left: 0;
`;

export interface BoothLiveStreamVolumeIndicatorProps {
  audioTrack: ILocalAudioTrack | null;
  toggleAudio: () => void;
  selectedVerifiedMicrophoneId: string;
}

const LiveStreamBoothExhibitorPanelVolumeIndicator: FC<BoothLiveStreamVolumeIndicatorProps> = ({
  audioTrack,
  toggleAudio,
  selectedVerifiedMicrophoneId,
}) => {
  const volume$ = useMemo(() => interval(50).pipe(
    map(() => audioTrack?.getVolumeLevel() ?? 0),
  ), [audioTrack]);

  const volume = useObservable(volume$);

  return (
    <Tooltip title={audioTrack ? 'Voice streaming' : 'Voice muted'}>
      <IconButton onClick={toggleAudio} disabled={selectedVerifiedMicrophoneId == null}>
        {audioTrack ? <Mic /> : <MicOff />}
        {audioTrack && (
          <StyledMicColorOverlayContainer>
            <StyledMicColorOverlay style={{ height: `${volume * 100}%` }}>
              <StyledMic />
            </StyledMicColorOverlay>
          </StyledMicColorOverlayContainer>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default React.memo(LiveStreamBoothExhibitorPanelVolumeIndicator);
